const carouselItems = [
  {
    title: '红桃视频 · 夏日追番指南',
    desc: '精选红桃视频频道本月最热连载，从都市情感到青春成长，十部必追好片一网打尽。',
    tag: '热门推荐',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20crimson%20and%20rose%20gradient%20with%20floating%20geometric%20petal%20shapes%20and%20soft%20golden%20light%20streaks%2C%20luxurious%20cinematic%20atmosphere%2C%20rich%20red%20tones%20on%20deep%20dark%20background%2C%20minimalist%20elegant%20composition&width=1000&height=600&seq=carousel-heart&orientation=landscape'
  },
  {
    title: '小蓝视频 · 经典修复全收录',
    desc: '小蓝视频频道经典作品4K修复版合集，重温那些年追过的数字颜色系列佳作。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20moody%20teal%20and%20navy%20gradient%20with%20flowing%20wave%20patterns%20and%20bright%20cyan%20accents%2C%20cinematic%20oceanic%20mood%2C%20deep%20blue%20tones%20on%20dark%20surface%2C%20minimalist%20luxury%20digital%20art&width=1000&height=600&seq=carousel-blue&orientation=landscape'
  },
  {
    title: '黑桃视频 · 暗夜剧场精选',
    desc: '黑桃视频深夜专属剧场，悬疑、惊悚、文艺片单，为追求品质的观众精心编排。',
    tag: '品质之选',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20charcoal%20and%20onyx%20with%20sharp%20angular%20geometric%20cuts%20and%20subtle%20crimson%20glow%2C%20dramatic%20noir%20atmosphere%2C%20minimalist%20mysterious%20composition%2C%20luxury%20dark%20digital%20art&width=1000&height=600&seq=carousel-spade&orientation=landscape'
  },
  {
    title: '91视频 · 都市夜话专刊',
    desc: '91视频风格专题策划，聚焦当代都市生活、情感观察与人际关系深度解读系列。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20copper%20gradient%20with%20glowing%20rectangular%20panels%20and%20soft%20light%20leaks%2C%20urban%20night%20cinematic%20mood%2C%20luxurious%20golden%20hour%20tones%20on%20dark%20background&width=1000&height=600&seq=carousel-91&orientation=landscape'
  },
  {
    title: '久久视频 · 周末影院特辑',
    desc: '久久视频周末限免合集，精选高口碑数字颜色系列作品，一次看个够的观影盛宴。',
    tag: '限免特辑',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20plum%20and%20mauve%20gradient%20with%20soft%20overlapping%20circle%20shapes%20and%20gentle%20light%20glow%2C%20elegant%20cinematic%20atmosphere%2C%20warm%20purple%20undertones%20on%20dark%20minimalist%20background%2C%20luxury%20digital%20composition&width=1000&height=600&seq=carousel-99&orientation=landscape'
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="relative py-14 md:py-20 bg-background-900/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-accent-400 font-medium tracking-wider uppercase mb-2">Spotlight</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">焦点专题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">妖精视频数字颜色系列深度专题策划，一探热门频道精华</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group relative bg-background-800/40 rounded-lg overflow-hidden border border-background-700/30 hover:border-primary-500/20 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-40 md:h-48 bg-background-700/40 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/80 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2 py-1 rounded-full bg-primary-500/80 backdrop-blur-sm text-foreground-50 font-medium whitespace-nowrap">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-heading text-foreground-200 group-hover:text-foreground-50 transition-colors duration-200 tracking-wide line-clamp-2">{item.title}</h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">{item.desc}</p>
                <div className="mt-3 pt-3 border-t border-background-700/30 flex items-center text-xs text-primary-400">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform duration-200"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}